import { Sparkle, Buildings, Users, Trophy, Storefront, ChartBar, ListChecks, Calculator, Coins, Percent } from '@phosphor-icons/react';

/**
 * Tour step config — each tool has 4 steps. Strings are i18n keys
 * resolved at render time via t(...).
 */
export const TOOL_TOURS = {
  geo: [
    { titleKey: 'tour.geo.s1.title', bodyKey: 'tour.geo.s1.body', icon: Sparkle },
    { titleKey: 'tour.geo.s2.title', bodyKey: 'tour.geo.s2.body', icon: Buildings },
    { titleKey: 'tour.geo.s3.title', bodyKey: 'tour.geo.s3.body', icon: Users },
    { titleKey: 'tour.geo.s4.title', bodyKey: 'tour.geo.s4.body', icon: Trophy },
  ],
  competitor: [
    { titleKey: 'tour.competitor.s1.title', bodyKey: 'tour.competitor.s1.body', icon: Sparkle },
    { titleKey: 'tour.competitor.s2.title', bodyKey: 'tour.competitor.s2.body', icon: Storefront },
    { titleKey: 'tour.competitor.s3.title', bodyKey: 'tour.competitor.s3.body', icon: Users },
    { titleKey: 'tour.competitor.s4.title', bodyKey: 'tour.competitor.s4.body', icon: ChartBar },
  ],
  analytics: [
    { titleKey: 'tour.analytics.s1.title', bodyKey: 'tour.analytics.s1.body', icon: Sparkle },
    { titleKey: 'tour.analytics.s2.title', bodyKey: 'tour.analytics.s2.body', icon: Storefront },
    { titleKey: 'tour.analytics.s3.title', bodyKey: 'tour.analytics.s3.body', icon: ChartBar },
    { titleKey: 'tour.analytics.s4.title', bodyKey: 'tour.analytics.s4.body', icon: ListChecks },
  ],
  pricing: [
    { titleKey: 'tour.pricing.s1.title', bodyKey: 'tour.pricing.s1.body', icon: Calculator },
    { titleKey: 'tour.pricing.s2.title', bodyKey: 'tour.pricing.s2.body', icon: Coins },
    { titleKey: 'tour.pricing.s3.title', bodyKey: 'tour.pricing.s3.body', icon: Percent },
    { titleKey: 'tour.pricing.s4.title', bodyKey: 'tour.pricing.s4.body', icon: ChartBar },
  ],
};

/** Hook-friendly helper that resolves i18n keys against the current `t`. */
export function buildSteps(tourId, t) {
  return (TOOL_TOURS[tourId] || []).map((s) => ({
    title: t(s.titleKey),
    body: t(s.bodyKey),
    icon: s.icon,
  }));
}
